<template>
  <user-personal-data-form></user-personal-data-form>
</template>

<script>
import UserPersonalDataForm from "../../../components/Settings/Users/UserPersonalDataForm";
export default {
  name: "AdminUsersEditBasicView",
  components: { UserPersonalDataForm }
};
</script>

<style scoped></style>
